import React from 'react';
import { Spinner } from 'react-bootstrap';

import styles from './Loader.module.scss';

export const Loader = () => (
  <div className={styles.loader}>
    <Spinner animation="border" variant="danger" className={styles.spinner} />
  </div>
);
